import { getIndustry } from './basicCreators';

export function updateCurrentIndustry(industryId) {
  return function(dispatch, getState) {
    if (industryId) {
      // Get the industry details
      return dispatch(getIndustry(industryId)).then(
        industry => dispatch({ type: 'UPDATE_CURRENT_INDUSTRY', industry })
      );
    } else {
      return dispatch(clearCurrentIndustry());
    }
  }
}

export function clearCurrentIndustry() {
  return { type: 'CLEAR_CURRENT_INDUSTRY' }
}



// WEBPACK FOOTER //
// ./src/actions/industries/currentIndustryCreators.js